import { ViewLodgingRequestState, ViewLodgingRequestActionTypes, VIEW_LODGING_REQUESTS_DATA_REQUEST, VIEW_LODGING_REQUESTS_DATA_SUCCESS, VIEW_LODGING_REQUESTS_DATA_FAILURE } from "store/reducers/lodgingRequest/view/types";

const defaultState: ViewLodgingRequestState = {
  isLoading: false,
  errorMessage: ""
};

export default function viewLodgingRequests(state = defaultState, action: ViewLodgingRequestActionTypes): ViewLodgingRequestState {
  switch (action.type) {
    case VIEW_LODGING_REQUESTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case VIEW_LODGING_REQUESTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case VIEW_LODGING_REQUESTS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};